import { getCsrfValue } from "~/api/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const apiUrl = resolveApiUrl("/cart/sendCart");

interface RequestCartData {
  requestNumber: string;
  tcConsent: boolean;
  ppConsent: boolean;
  marketingConsent: boolean;
}

export const requestCart = (data: RequestCartData): Promise<unknown> => {
  return fetch(apiUrl, {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response;
    }
  });
};
